import React, { useState, useEffect } from "react";

export default function ({
  label,
  name,
  register,
  errorMessage = "",
  rows = 3,
  classes = "",
  event = false,
  eventNameClasses = "",
  maxChars = 225,
  watch,
  required = false,
  readOnly = false
}) {
  const currentValue  = watch(name);

  return (
    <>
      <div className="fv-row mb-10">
        <label className="form-label fs-6 fw-bolder text-dark">
          {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
        </label>
        {event && (<span className={`event-name float-right${currentValue?.length > maxChars ? ' text-danger' : ''}`}>
          Characters:
          <span className="event-value"> {currentValue?.length || 0}</span>
        </span>)
        }
        <textarea
          className={`form-control form-control-lg form-control-solid${classes ? " " + classes : ''}`}
          {...register(name)}
          rows={rows}
          required={required}
          readOnly={readOnly}
        >
        </textarea>

        {errorMessage && (
          <div className="fv-plugins-message-container invalid-feedback">
            <div>{errorMessage}</div>
          </div>
        )}
      </div>
    </>
  );
}